import React from 'react'
import { useTranslation } from 'react-i18next'
import { SCREEN_TENANT_DOCUMENTS, SCREENS } from '../../../../../../services/domain/wizardScreens'
import { FieldProps } from '../../../../../../@types/types'
import ChipsGroup, { ChipGroupFeature } from '../../../../../common/inputs/chipsGroup/ChipsGroup'
import { AbstractScreenValidationResult } from '../../../../../../@types/validation-types'

const screen = SCREENS[SCREEN_TENANT_DOCUMENTS]
type AdditionalTenantDocumentsProps = {
  tenantDocuments: ChipGroupFeature[]
}
const TenantDocumentsGroup: React.FC<FieldProps<AbstractScreenValidationResult> & AdditionalTenantDocumentsProps> = ({
  tenantDocuments,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <span className='font-body-small-regular font-lightgray'>
        {t('wizard.screen.tenantDocuments.hint', 'Multiple selection possible')}
      </span>
      <ChipsGroup
        id='tenant-documents'
        className='margin-top-xs margin-bottom-xxl'
        features={tenantDocuments}
        translation='wizard.screen.tenantDocuments.documents.'
        onChange={(property, value) => onChange({ screen: screen.name, property }, value)}
      />
    </>
  )
}

export default TenantDocumentsGroup
